import { useEffectOnce } from 'react-use';

const EDITABLE_SELECTOR = 'input, textarea';

const useDisableSelection = () => {
	useEffectOnce(() => {
		const getSelectionTarget = (target: EventTarget | null): Element | null => {
			if (target instanceof Element) {
				return target;
			}

			return target instanceof Node ? target.parentElement : null;
		};

		const getEditableElement = (target: EventTarget | null): Element | null => {
			const element = getSelectionTarget(target);

			if (!element) {
				return null;
			}

			return element.closest(EDITABLE_SELECTOR);
		};

		const handleSelectStart = (e: Event) => {
			const editableElement = getEditableElement(e.target);
			if (!editableElement || editableElement === document.activeElement) {
				return;
			}

			e.preventDefault();
		};

		document.addEventListener('selectstart', handleSelectStart);
		return () => document.removeEventListener('selectstart', handleSelectStart);
	});
};

export { useDisableSelection };
